const statusColorClass = [
  'status--waiting',
  'status--prioritized',
  'status--pendency',
  'status--development',
  'status--finished',
];

export { statusColorClass };
